<i18n>
{
  "en":{
    "loading": "Loading..."
    
  },
  "zhHant":{
    "loading": "讀取中..."
  },
  "ja":{
    "loading": "読み込み中..."
  },
  "ko":{
    "loading": "읽는 중..."
  }
}
</i18n>

<template>
  <div :style="{ height: (height || 160) + 'px' }" ref="parent" style="overflow: hidden">
    <div v-if="showLoading">{{ $t('loading') }}</div>
    <VueC3 :handler="handler" style="margin-right: -50px" />
  </div>
</template>

<script>
import Vue from 'vue';
import VueC3 from 'vue-c3';
import * as d3 from 'd3';
import LazyRender from 'vue-lazy-render';
Vue.use(LazyRender);

export default {
  props: ['data', 'bits', 'height'],
  components: {
    VueC3,
  },
  data() {
    return {
      showLoading: true,
      chartData: [],
      handler: new Vue(),
      delayId: 0,
    };
  },
  mounted() {
    this.delayRender();
  },
  watch: {
    data: function () {
      this.delayRender();
    },
  },
  methods: {
    delayRender() {
      if (this.delayId !== 0) {
        clearTimeout(this.delayId);
      }
      this.delayId = setTimeout(() => {
        if (this.bits !== undefined) {
          this.genChartBits();
        } else {
          this.chartData = this.data;
          this.genChart();
        }
      }, 500 + Math.random() * 1000);
    },
    genChartBits() {
      const options = {
        size: { height: this.height || 160 },
        data: {
          x: 'Days',
          epochs: 'Count',
          columns: this.genColumnsBits(this.bits),
          type: 'stanford',
        },
        tooltip: { show: false },
        legend: { hide: true, position: 'inset', show: false },
        point: { focus: { expand: { r: 3 } }, r: 2 },
        axis: {
          x: {
            show: true,
            min: 0.5,
            max: 32,
            tick: { values: d3.range(0, 32, 3) },
            padding: { top: 0, bottom: 0, left: 0, right: 2 },
          },
          y: {
            show: true,
            min: 0,
            max: 24,
            tick: { values: d3.range(0, 100, 8) },
            padding: { top: 5, bottom: 0, left: 0, right: 0 },
          },
        },
        stanford: {
          scaleMin: 0,
          scaleMax: 1,
          colors: v => {
            if (v >= 0.5) {
              return 'rgb(255, 0, 0)';
            } else {
              return 'rgb(255, 220, 220)';
            }
          },
          padding: { top: 5, right: 0, bottom: 0, left: 4 },
        },
      };
      this.showLoading = false;
      this.handler.$emit('init', options);
    },
    genChart() {
      // const minMax = this.getMinMaxV2(this.chartData);
      const options = {
        size: { height: this.height || 160 },
        data: {
          x: 'Days',
          epochs: 'Count',
          columns: this.genColumns(this.chartData),
          type: 'stanford',
        },
        tooltip: { show: false },
        legend: { hide: true, position: 'inset', show: false },
        point: { focus: { expand: { r: 3 } }, r: 2 },
        axis: {
          x: {
            show: true,
            min: 0.5,
            max: 32,
            tick: { values: d3.range(0, 32, 3) },
            padding: { top: 0, bottom: 0, left: 0, right: 4 },
          },
          y: {
            show: true,
            min: -1,
            max: 23,
            tick: { values: d3.range(0, 100, 4) },
            padding: { top: 5, bottom: 0, left: 0, right: 0 },
          },
        },
        stanford: {
          colors: d3.interpolateHslLong(d3.rgb(240, 240, 240), d3.rgb(250, 20, 20)),
          padding: { top: 5, right: 0, bottom: 0, left: -15 },
        },
      };
      this.showLoading = false;
      this.handler.$emit('init', options);
    },
    genColumnsBits(bits) {
      const columns = [['Days'], ['Hours'], ['Count']];
      for (let d = 0; d < 31; d++) {
        for (let h = 0; h < 24; h++) {
          const idx = d * 24 + h;
          if (bits.get(idx) === false) {
            continue;
          }
          columns[0].push(d + 1);
          columns[1].push(h);
          columns[2].push(1);
        }
      }
      return columns;
    },
    genColumns(data) {
      const columns = [['Days'], ['Hours'], ['Count']];
      for (let d = 0; d < 31; d++) {
        for (let h = 0; h < 24; h++) {
          const idx = d * 24 + h;
          if (data[idx] === 0) {
            continue;
          }

          columns[0].push(d + 1);
          columns[1].push(h);
          columns[2].push(data[idx]);
        }
      }
      return columns;
    },
    getMinMax(data) {
      let min = Number.MAX_VALUE;
      let max = Number.MIN_VALUE;
      for (var i = 0; i < data.length; i++) {
        min = Math.min(min, data[i]);
        max = Math.max(max, data[i]);
      }
      return { min, max };
    },
    getMinMaxV2(data) {
      const tmpData = data.slice(0, data.length).sort();
      const min = tmpData[Math.floor(data.length / 6)];
      const max = tmpData[Math.floor((data.length * 5) / 6)];
      return { min, max };
    },
    delay(time) {
      return new Promise(resolve => {
        setTimeout(resolve, time);
      });
    },
  },
};
</script>

<style>
@import '../../misc/c3.min.css';
.c3-colorscale {
  display: none;
}
</style>
